export const EMPTY_ARRAY = [];